export enum UserSystem {
    DASHBOARD = "D",
    CETADEL = "C"
}